var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.programs),function(program){return _c('div',{key:program.id,staticClass:"courseSectionContainer"},[_c('div',{staticClass:"courseHeader"},[_c('b',{staticClass:"courseTitle"},[_vm._v(_vm._s(program.name)+" Pilot")])]),_c('div',{staticClass:"cardsContainer"},_vm._l((_vm.classes.filter(
          (data) => data.curriculum.programId === program.id,
        )),function(classObj){return _c('ClassCards',{key:classObj.id,attrs:{"course":classObj}})}),1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }